import React, { Component } from 'react';
import { Col, Modal } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { api } from '../../api/api';
import { Alert, AlertErro } from '../../../util/Alertas';
import { FormataDataBrToEng } from '../../../util/FormatacaoUtil';
import Calendar from '../../../components/ui/Calendar'

class AlterarDataEstimadaEntregaModal extends Component {
    constructor(props) {
        super(props);
        this.state = this.initialState
        this.Open = (pedidoId, dataEstimada = '', dias = []) => this.setState({
            show: true,
            id: pedidoId,
            data: dataEstimada,
            dias: dias
        })
    }

    initialState = {
        show: false,
        id: 0,
        data: '',
        dias: []
    }

    handleClose = () => {
        this.setState(this.initialState)
        this.props.hadleReloadPage && this.props.hadleReloadPage()
    };

    handleSubmit = e => {
        const { id, data } = this.state;

        const formData = new FormData();
        formData.append("data", FormataDataBrToEng(data));

        api.post(`api/Pedido/Entrega/${id}`, formData, res => {
            Alert('Data atualizada com sucesso!');
            this.handleClose();
        }, err => {
            console.clear();
            console.log(err);
            AlertErro(err, 'Houve um erro ao salvar os dados');
        })
    }

    render() {
        const { show, data, id } = this.state;

        return (
            <Modal show={show}>
                <Modal.Header>
                    <h2>Alterar Data Estimada Entrega</h2>
                </Modal.Header>
                <Modal.Body>
                    <label>Informe a data estimada para entrega</label>
                    <Calendar
                        selectedDate={new Date(this.state.data)}
                        setSelectedDate={(date) => this.setState({ ...this.state, data: date })}
                        allowedDays={this.state.dias ?? []}
                        disablePastDates
                    />
                    {/* <DatePicker
                        style={{ witdh: '100%' }}
                        selected={data}
                        withPortal={'100%'}
                        onChange={(date) => this.setState({ ...this.state, data: date })}
                        minDate={new Date()}
                        dateFormat="dd/MM/yyyy"
                        className="w-full form-control"
                    /> */}
                </Modal.Body>
                <Modal.Footer>
                    <button className='btn btn-danger' onClick={this.handleClose}>Cancelar</button>
                    <button onClick={this.handleSubmit} disabled={!data || id === 0} className='btn btn-primary' type='submit'>Atualizar</button>
                </Modal.Footer>
            </Modal >
        );
    }
}

export default AlterarDataEstimadaEntregaModal;